import { useLocation } from 'react-router-dom';
import BodyTitle from '../../../component/BodyTitle';
import BreadCrumb from '../../../component/BreadCrumb';
import AuthenticationUtil from '../../../util/AuthenticationUtil';
import { CommunityRouter } from '../../../util/RouterUtil';
import ViewWrapper from '../../ViewWrapper';

const CommunityRouterView = () => {
    const auth = AuthenticationUtil.get();
    const pathname = useLocation().pathname;
    return (
        <div className='body-view'>
            <ViewWrapper router={CommunityRouter} />
        </div>
    );
};

export default CommunityRouterView;
